import * as React from 'react'
import QuestionnaireCommentView from './QuestionnaireCommentView'
import LocalizationStore from '../../../Stores/LocalizationStore'
import { Questionnaire } from '../../../Model/Questionnaire'
import { inject, observer } from 'mobx-react'
import * as _ from 'lodash'
import * as ReactDOM from 'react-dom'

export interface IQuestionnaireCommentsViewProps {
    className?: string
    questionnaire?: Questionnaire
    localizationStore?: LocalizationStore
}

@inject('localizationStore')
@observer
export default class QuestionnaireCommentsView extends React.Component<IQuestionnaireCommentsViewProps> {

    el: HTMLDivElement | null

    componentDidMount() {
        this.scrollToBottom()
    }

    componentDidUpdate() {
        this.scrollToBottom()
    }

    scrollToBottom() {
        const messagesContainer = ReactDOM.findDOMNode(this.el!)
        messagesContainer.scrollTop = messagesContainer.scrollHeight
    }

    render() {
        const { localizationStore } = this.props
        return (
            <div className={this.props.className} hidden={!this.props.questionnaire!.id}>
                <div className="container p-0">
                    <div className="row">
                        <p className="comments">{localizationStore!.t!('Comments')}</p>
                    </div>

                    <div
                        className="row blockComments"
                        ref={el => { this.el = el }}
                    >
                        {
                            this.props.questionnaire!.comments && this.props.questionnaire!.comments.length > 0 ?
                                _.orderBy(this.props.questionnaire!.comments!, ['createDate'], ['asc']).map(x =>
                                    <QuestionnaireCommentView className="col-12 blockComment" key={x.id} comment={x} />)
                                : <p>{localizationStore!.t('no comments yet...')}</p>
                        }
                    </div>
                </div>

            </div>
        )
    }
}


// WEBPACK FOOTER //
// ./node_modules/tslint-loader!./src/Views/PartialViews/Questionnaire/QuestionnaireCommentsView.tsx